import React, { useRef } from 'react'
import ClickableImageCard from '../custom-components/ClickableImageCard';
import './IMW.css'

function IndianMensWear() {

    const carouselRef = useRef(null);
        
        const scroll = (direction) => {
            const scrollAmount = 300;
            carouselRef.current.scrollBy({
            left: direction === 'left' ? -scrollAmount : scrollAmount,
            behavior: 'smooth'
            });
        };

        const deals = [
            {id: 1, imw: "one", image: "https://assets.tatacliq.com/medias/sys_master/images/63588844404766.png"},
            {id: 2, imw: "two", image: "https://assets.tatacliq.com/medias/sys_master/images/63588844470302.png"},
            {id: 3, imw: "three", image: "https://assets.tatacliq.com/medias/sys_master/images/63588844535838.png"},
            {id: 4, imw: "four", image: "https://assets.tatacliq.com/medias/sys_master/images/63588844601374.png"},
            {id: 5, imw: "five", image: "https://assets.tatacliq.com/medias/sys_master/images/63588844666910.png"},
            {id: 6, imw: "six", image: "https://assets.tatacliq.com/medias/sys_master/images/63588844732446.png"},
            {id: 7, imw: "seven", image: "https://assets.tatacliq.com/medias/sys_master/images/63588844797982.png"},
        ];


        return (
            <div className="carousel-container">
              <div className="carousel-controls justify-content-end mb-5">
                  <button onClick={() => scroll('left')} className="control-button">
                    &lt;
                  </button>
                  <button onClick={() => scroll('right')} className="control-button">
                    &gt;
                  </button>
                </div>
              
              <div className="image-carousel" ref={carouselRef}>
                {deals.map((deal) => (
                  <ClickableImageCard key={deal.id} item={deal} />
                ))}
              </div>
            </div>
          );
}

export default IndianMensWear